// helpers/searchFilters.ts
import type { FiltersValues } from '@/modules/PetSitter/searchServiceHelper'

import type { SlotsByService } from '@/store/newRequestCartStore'

type PetSlug = 'dog' | 'cat' | 'nac'

// si ton API attend des slugs différents, map ici
const serviceToSearchSlug: Record<string, string> = {
  promenade: 'walk',
  'garde-chez-vous': 'sittingAtCustomerHome',
  'garde-chez-eux': 'sittingAtPetsitterHome',
  visite: 'homeVisit',
}

const searchToServiceSlug: Record<string, string> = Object.fromEntries(
  Object.entries(serviceToSearchSlug).map(([k, v]) => [v, k]),
)

// Rayon par défaut : plus large pour les gardes que pour les promenades / visites
export function getDefaultSearchDistance(service?: string | null): { min: number; max: number } {
  return service === 'garde-chez-eux' || service === 'garde-chez-vous' ? { min: 0, max: 15 } : { min: 0, max: 10 }
}

export function storeToFilters(store: {
  address?: any
  distance?: { min: number; max: number }
  selectedService?: string | null
  petsToComplete?: { slug: PetSlug; number: number }[]
  formSlotsByService?: SlotsByService
}): FiltersValues {
  const pets = store.petsToComplete?.filter((p) => p.number > 0).map((p) => p.slug) ?? []
  return {
    sortBy: 'recommender',
    period: {
      start: store.formSlotsByService?.[store.selectedService ?? '']?.[0]?.data?.dateStart ?? null,
      end: store.formSlotsByService?.[store.selectedService ?? '']?.[0]?.data?.dateEnd ?? null,
    },
    address: store.address ?? null,
    distance: store.distance ?? { min: 0, max: 20 },
    services: store.selectedService ? serviceToSearchSlug[store.selectedService] ?? store.selectedService : '',
    petCount: null,
    pets,
    petSize: [],
    features: [],
  }
}

export function filtersToStorePatch(filters: Partial<FiltersValues>): {
  address?: any
  distance?: { min: number; max: number }
  selectedService?: string | null
  petsToComplete?: { slug: PetSlug; number: number }[]
} {
  const patch: any = {}

  if ('address' in filters) patch.address = filters.address ?? undefined
  if ('distance' in filters && filters.distance) patch.distance = filters.distance
  if ('petCount' in filters && filters.petCount) patch.petCount = filters.petCount

  if ('services' in filters) {
    const s = filters.services || null
    patch.selectedService = s ? searchToServiceSlug[s] ?? s : null
  }

  if ('pets' in filters) {
    const selected = new Set((filters.pets ?? []) as PetSlug[])
    patch.petsToComplete = (['dog', 'cat', 'nac'] as const).map((slug) => ({
      slug,
      number: selected.has(slug) ? 1 : 0, // ou une autre règle si tu gères des quantités
    }))
  }

  return patch
}
